import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import Uploadimage from "../weigthscale/uploadimage";

const schema = yup.object({
  fname: yup.string().required("ระบุชื่อ"),
  lname: yup.string().required("ระบุสกุล"),
  account: yup.string().required("ระบุ account"),
  password: yup.string().required("ระบุ password"),
  code: yup.string().required("ระบุรหัสลูกค้า"),
  type: yup.number().min(1).required("ระบุประเภท"),
  codeid: yup.string().required("ระบุระหัสบัตรประชาชน"),
  producttype: yup.string().required("ระบุประเภทสินค้า"),
  telephone: yup.string().required("ระบุเบอร์โทร"),
  number: yup.string().required("ระบุชื่อ"),
  moo: yup.string().required("ระบุหมู่"),
  aumper: yup.string().required("เลือกอำเภอ"),
  provine: yup.string().required("เลือกจังหวัด"),
  tumbol: yup.string().required("เลือกตำบล"),
  zipcode: yup.string().required("ระบุรหัสไปรษณีย์"),
  bankname: yup.string().required("ระบุชื่อธนาคาร"),
  accountname: yup.string().required("ระบุชื่อบัญชี"),
  accountnumber: yup.string().required("กรอกหมายเลขบัญชี"),
});

const Request = ({ isOpen, onCancel, onConfirm, list }) => {
  const [endDate, setEndDate] = useState(new Date());
  const handleChangEndDate = (event) => {
    setEndDate(event);
  };
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = (data) => {};

  const handleCancle = (e) => {
    onCancel(false);
  };

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <Modal
          className="modal-dialog modal-xl"
          isOpen={isOpen}
          toggle={onCancel}
          centered
        >
          <ModalHeader>
            <span className="fs-2 fw-bold text-primary">
              <i className="bi bi-pencil-square fs-3 me-3"></i>
              แจ้งงานเพิ่มเติม
            </span>
          </ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-center">
              <div className="col-lg-9">
                <div className="row d-flex justify-content-center">
                  <div className="row d-flex justify-content-center">
                    <div className="mb-2 col-lg-12 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label fs-5"
                      >
                        <i className="bi bi-book-half text-info me-2"></i>{" "}
                        หัวข้องาน
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput1"
                      />
                    </div>
                    <div className="mb-2 col-lg-12">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="form-label fs-5"
                      >
                        <i className="bi bi-border-width text-info me-2"></i>
                        อธิบายเพิ่มเติม
                      </label>
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows={3}
                        placeholder="เพิ่มคำอธิบายโดยละเอียด"
                      />
                    </div>
                  </div>
                  <div className="row mb-2 ">
                    <div className="col-lg-4 m-2">
                      <span className="fs-5">
                        <i className="bi bi-check-circle-fill text-info me-2"></i>{" "}
                        วันที่ต้องการเสร็จ
                       
                      </span>
                      <div className="mt-2">
                        <DatePicker
 className="datepicker-default form-control"
                          todayButton="Today"
                          dateFormat="dd/MM/yyyy"
                          selected={endDate}
                          onChange={handleChangEndDate}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12  ">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="form-label fs-5"
                      >
                        <i className="bi bi-paperclip text-info fs-4 me-2"></i>
                        ไฟล์แนบ
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <Uploadimage />
                    </div>
                    <div className="col-lg-6">
                      <Uploadimage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="col-auto me-3">
              <div className="row">
                <div className="col-auto">
                  <Button color="primary" onClick={handleSubmit(onSubmit)}>
                    Confirm
                  </Button>
                </div>
                <div className=" col-auto">
                  <Button color="secondary" onClick={handleCancle}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </form>
    </>
  );
};

export default Request;
